<div class="message">
    <h1>Page Not Found</h1>
    <div>Page you are looking for could not be found</div>
    <div class="buttons">
        <a class="bp hero" [routerLink]='["/"]'><i class="fa fa-home" aria-hidden="true"></i> Go to Home Page</a>
    </div>
</div>
